import classNames from "classnames";
import CustomLink from "./custom-link";
import { IsidebarItem } from "./sidebar";
import './sidebar-item.less'

interface Iprops {
    /**
     * 当前项目的路由信息
     */
    route?: IsidebarItem

    /**
     * 当前激活的项目 ID
     */
    activedRouteUuid?: string,

    /**
     * 当前项目是否被选中
     */
    selected?: boolean,

    /**
     * 激活当前项目的点击事件
     */
    onActiveClick?: () => void

    /**
     * 切换激活状态的回调函数
     * @param routeId 要激活的项目 ID
     */
    toggleActiveRoute?: (routeUuid: string) => void,

    /**
     * 右键菜单的回调事件
     */
    onContextMenu?: React.MouseEventHandler<HTMLDivElement>
}

/**
 * `SidebarItem` 组件
 * 用于渲染侧边栏中的单个项目。
 */
export default function SidebarItem(props: Iprops) {

    return (
        <div className={classNames({
            'sidebar-item': true,
            'active': props.route?.uuid === props.activedRouteUuid,
            'selected': props.selected,
        })} onContextMenu={props.onContextMenu}>
            {props.route?.url && (
                <CustomLink to={props.route?.url} active={(active) => { if (active) { props.toggleActiveRoute(props.route?.uuid) } }} className="item-content" themecolor={props.route?.themeColor || null} >
                    <div style={{
                        width: '24px',
                        height: '100%'
                    }}>
                        {props.route?.icon}
                    </div>
                    <div className="item-name">
                        {props.route?.name}
                    </div>
                </CustomLink>
            )}
        </div>
    )
}